// Views / Routes
const ROUTE_HOME = 'Homepage';
const ROUTE_RECIPIENTS = 'Recipients';
const ROUTE_TOPICS = 'Topics';
const ROUTE_TOPIC = 'Topic';
const ROUTE_CONTENT_SECTION = 'Content Section';
const ROUTE_SAVED_INFO = 'Saved Info';
const ROUTE_SHARE_CONTENT = 'Share Content';
const ROUTE_FINISHED = 'Finished';
const ROUTE_SHARED = 'Shared';
const ROUTE_GENERAL = 'General';
const ROUTE_NOT_FOUND = 'Not Found';

export {
	ROUTE_HOME,
	ROUTE_RECIPIENTS,
	ROUTE_TOPICS,
	ROUTE_TOPIC,
	ROUTE_CONTENT_SECTION,
	ROUTE_SAVED_INFO,
	ROUTE_SHARE_CONTENT,
	ROUTE_FINISHED,
	ROUTE_SHARED,
	ROUTE_GENERAL,
	ROUTE_NOT_FOUND
};